function fitTextAll() {
  const containers = document.querySelectorAll(".custom-section-content .section-content-wrapper");

  if (!containers.length) return;

  containers.forEach(container => {
    const text = container.querySelector("h1");
    if (!text) return;

    const sampleSize = 100;
    text.style.fontSize = sampleSize + "px";

    const naturalWidth = text.offsetWidth;
    const containerWidth = container.offsetWidth;

    if (naturalWidth === 0 || containerWidth === 0) return;

    const ratio = containerWidth / naturalWidth;
    const newFont = sampleSize * ratio;

    text.style.fontSize = newFont + "px";
  });
}

function fitTextStable() {
  // Aspetta il caricamento del font → molto importante
  document.fonts.ready.then(() => {
    // Aspetta 2 frame per layout stabile
    requestAnimationFrame(() => {
      requestAnimationFrame(fitTextAll);
    });
  });
}

// Eventi classici
window.addEventListener("load", fitTextStable);
window.addEventListener("resize", fitTextStable);

// Eventi Shopify
document.addEventListener("shopify:section:load", fitTextStable);
document.addEventListener("turbo:load", fitTextStable);
